<template>
    <div id="app">
        <transition name="slide" mode="out-in">
            <router-view></router-view>
        </transition>
        <div v-if="development">
            <button v-if="!showbtns" @click="showbtns = true" style="position: absolute; bottom: 0px; left: 0px">Show devtools</button>
            <div v-if="showbtns">
                <br /><br /><br />
                <div class="well">
                    <button class="pull-right" v-if="showbtns" @click="showbtns = false">Hide</button>
                    <h4>Development tools</h4>
                    <div class="row">
                        <h5>Task state:</h5>
                        <button class="btn btn-default" @click="updateCurrentTaskStatus('clean')">Clean</button>
                        <button class="btn btn-default" @click="updateCurrentTaskStatus('started')">Started</button>
                        <button class="btn btn-default" @click="updateCurrentTaskStatus('completed')">Complete</button>
                        <button class="btn btn-default" @click="updateCurrentTaskStatus('aborted')">Aborted</button>
                    </div>
                    <div class="row">
                        <h5>Context state</h5>
                        <button class="btn btn-default" @click="updateCurrentContext('done')">Done</button>
                        <button class="btn btn-default" @click="updateCurrentContext('consent')">Consent</button>
                        <button class="btn btn-default" @click="updateCurrentContext('task')">Task</button>
                        <button class="btn btn-default" @click="updateCurrentContext('feedback')">Feedback</button>
                    </div>
                    <div class="row">
                        <h5>Task part</h5>
                        <button class="btn btn-default" @click="updateCurrentTaskComponent('instruction')">Instruction</button>
                        <button class="btn btn-default" @click="updateCurrentTaskComponent('training')">Training</button>
                        <button class="btn btn-default" @click="updateCurrentTaskComponent('trainingcompleted')">
                            Training Completed
                        </button>
                        <button class="btn btn-default" @click="updateCurrentTaskComponent('test')">Test</button>
                        <button class="btn btn-default" @click="updateCurrentTaskComponent('recall')">Recall</button>
                        <button class="btn btn-default" @click="updateCurrentTaskComponent('delayed')">Delayed</button>
                        <button class="btn btn-default" @click="updateCurrentTaskComponent('recognition')">Recognition</button>
                        <button class="btn btn-default" @click="updateCurrentTaskComponent('testcompleted')">Test Completed</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import log from './lib/logger'

export default {
    name: 'app',
    data() {
        return {
            development: process.env.DEVELOPMENT,
            showbtns: process.env.DEVELOPMENT,
        }
    },
    methods: {
        ...mapActions({
            changeTask: 'changeTask',
            changeComponent: 'changeTaskComponent',
            updateTask: 'updateTask',
            updateCurrentContext: 'updateCurrentContext',
            updateCurrentTaskStatus: 'updateCurrentTaskStatus',
            updateCurrentTaskComponent: 'updateCurrentTaskComponent',
            updateCurrentTaskComponentConnected: 'updateCurrentTaskComponentConnected'
        }),
        changeTaskComponent(component) {
            this.changeComponent(component)
        },
    },
    created() {
        log.info('[Memoro] - Welcome to Memoro!')
    },
}
</script>

<style lang="scss">
@import 'mixins';

#app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    font-size: 18px;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;

    color: #2c3e50;
}

.mobile-friendly-paragraph {
    text-align: left;
    @media screen and (max-width: $mobile-breakpoint) {
        padding-left: 10px !important;
        padding-right: 10px !important;
    }
}

.cod-container {
    @media screen and (max-width: $mobile-breakpoint) {
        padding-left: 0px !important;
        padding-right: 0px !important;
    }
}

.key {
    @media screen and (max-width: $mobile-breakpoint) {
        border-width: 0px !important;
        width: 100% !important;
    }
}

.stimuli-row {
    height: 45px;
    width: 50px;
    background-color: #eee;
    float: left;
    text-align: center;
    padding-top: 5px;
    margin-left: 2px;
}

.code-key-table {
    @media screen and (max-width: $mobile-breakpoint) {
        border-collapse: collapse;
        tr {
            td.stimuli-row,
            td.response-row {
                max-height: 40px;
                max-width: calc(100% / 9);
                margin: 0 auto;
                padding: 0px;
                border: 1px solid white;
                &.active-cell {
                    border: 2px;
                    border-color: black;
                    border-style: dashed;
                    padding-top: 0px;
                }
            }
        }
    }
}

.alert-pad {
    padding: 2px 8px;
}
.lifted {
    box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.6);
}

.slide-enter-active {
    animation: slide-in 400ms ease-out forwards;
}

.slide-leave-active {
    animation: slide-out 400ms ease-out forwards;
}

@keyframes slide-in {
    from {
        transform: translateY(-30px);
        opacity: 0;
    }
    to {
        transform: translateY(0);
        opacity: 1;
    }
}

@keyframes slide-out {
    from {
        transform: translateY(0);
        opacity: 1;
    }
    to {
        transform: translateY(-30px);
        opacity: 0;
    }
}

.form-signin {
    max-width: 330px;
    padding: 15px;
    margin: 0 auto;
}
.form-signin .form-signin-heading,
.form-signin .checkbox {
    margin-bottom: 10px;
}
.form-signin .checkbox {
    font-weight: normal;
}
.form-signin .form-control {
    position: relative;
    font-size: 16px;
    height: auto;
    padding: 10px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
}
.form-signin .form-control:focus {
    z-index: 2;
}
.form-signin input[type='text'] {
    margin-bottom: -1px;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
}
.form-signin input[type='password'] {
    margin-bottom: 10px;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
}
.account-wall {
    margin-top: 20px;
    padding: 10px 0px 20px 0px;
    background-color: #fcfcfc;
    -moz-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);

    @media screen and (max-width: $mobile-breakpoint) {
        margin: 0;
        padding: 0;
        width: 100%;
        -moz-box-shadow: none;
        -webkit-box-shadow: none;
        box-shadow: none;
    }
}
.login-title {
    color: #555;
    font-size: 18px;
    font-weight: 400;
    display: block;
}
.profile-img {
    width: 96px;
    height: 96px;
    margin: 0 auto 10px;
    display: block;
    -moz-border-radius: 50%;
    -webkit-border-radius: 50%;
    border-radius: 50%;
}
.need-help {
    margin-top: 10px;
}
.new-account {
    display: block;
    margin-top: 10px;
}
.vue-keyboard {
    margin: 20px 0;
}

.vue-keyboard button {
    padding: 20px 30px !important;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

.training,
.completed,
.test,
.instruction,
.aborted,
.completedTraining {
    font-size: 18px;
    margin-top: 10px;
    @media screen and (max-width: $mobile-breakpoint) {
        margin-top: 0px;
    }
}

#footer-image {
    margin-top: 30px;
    max-width: 100%;
}

.navbar {
    @media screen and (max-width: $mobile-breakpoint) {
        margin-bottom: 0px;
    }
}

.container {
    @media screen and (max-width: $mobile-breakpoint) {
        padding: 0px;
        margin: 0 auto;
    }
}

h1,
h2,
h3 {
    @media screen and (max-width: $mobile-breakpoint) {
        margin-top: 10px;
    }
}

.box-shadow-for-desktop-only {
    box-shadow: 0px 1px 15px rgba(0, 0, 0, 0.3);
    @media screen and (max-width: $mobile-breakpoint) {
        box-shadow: none;
    }
}

#panelContainer {
    margin-top: 10px;
    @media screen and (max-width: $mobile-breakpoint) {
        margin-top: 0px;
    }
}

h1,
h2 {
    font-weight: normal;
}

// override bootstrap class
.panel {
    @media screen and (max-width: $mobile-breakpoint) {
        border: none;
        -webkit-box-shadow: none;
        box-shadow: none;
    }
}

.trigger {
    min-height: 230px;
    @media screen and (max-width: $mobile-breakpoint) {
        min-height: calc(100vh - 100px) !important;
    }
}

#keyboard {
    @media screen and (max-width: $mobile-breakpoint) {
        margin-top: 30px;
        div.vue-keyboard-row {
            button.vue-keyboard-key {
                $keypad-margin: 5px;
                $keyboard-button-width: 88px;
                $keyboard-button-height: 75px;
                margin-right: $keypad-margin;
                margin-left: $keypad-margin;
                margin-top: $keypad-margin;
                margin-bottom: $keypad-margin;
                font-size: 22px;
                min-height: $keyboard-button-height;
                height: $keyboard-button-height;
                min-width: $keyboard-button-width;
                max-width: $keyboard-button-width;
                &.action {
                    padding-left: 13px !important;
                    padding-right: 13px !important;
                }
            }
        }
    }
}

#keyboard-simple {
    @media screen and (max-width: $mobile-breakpoint) {
        margin-top: 5px;
        margin-bottom: 5px;
        div.vue-keyboard-row {
            button.vue-keyboard-key {
                $keypad-margin: 5px;
                $keyboard-button-width: 88px;
                $keyboard-button-height: 75px;
                margin-right: $keypad-margin;
                margin-left: $keypad-margin;
                margin-top: $keypad-margin;
                margin-bottom: $keypad-margin;
                font-size: 22px;
                min-height: $keyboard-button-height;
                height: $keyboard-button-height;
                min-width: $keyboard-button-width;
                max-width: $keyboard-button-width;
            }
        }
    }
}

.hide-on-mobile {
    @media screen and (max-width: $mobile-breakpoint) {
        display: none;
    }
}

.dense-mobile-heading {
    @media screen and (max-width: $mobile-breakpoint) {
        margin-top: 6px;
        margin-bottom: 3px;
    }
}

.panel-body {
    @media screen and (max-width: $mobile-breakpoint) {
        padding-left: 15px;
        padding-right: 15px;
        margin-left: 0px;
        margin-right: 0px;
    }
}

#panel-body {
    @media screen and (max-width: $mobile-breakpoint) {
        padding-left: 0px;
        padding-right: 0px;
        margin-left: 0px;
        margin-right: 0px;
    }
}

.big-number-container {
    @media screen and (max-width: $mobile-breakpoint) {
        padding-right: 0px;
        font-size: 88px !important;
    }
}

.row {
    @media screen and (max-width: $mobile-breakpoint) {
        margin-right: 0px;
        margin-left: 0px;
    }
}

.no-padding-for-mobile {
    @media screen and (max-width: $mobile-breakpoint) {
        padding-left: 0px;
        padding-right: 0px;
    }
}

.custom-wrapper {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 10px;
    @media screen and (max-width: $mobile-breakpoint) {
        padding-left: 0px;
        padding-right: 0px;
    }
}

.custom-account-wall {
    background-color: #fff;
    padding-left: 5px;
    padding-right: 5px;
    padding-top: 15px;
    padding-bottom: 20px;
    @media screen and (max-width: $mobile-breakpoint) {
        padding-left: 0px;
        padding-right: 0px;
        padding-top: 0px;
        padding-bottom: 0px;
    }
}

.mobile-friendly-select {
    display: inline-block;
    @media screen and (max-width: $mobile-breakpoint) {
        display: block;
        margin-top: 5px;
        width: 100%;
    }
}

.panel-scope,
.no-overflow-on-mobile {
    overflow: auto;
    @media screen and (max-width: $mobile-breakpoint) {
        overflow: hidden;
        width: 100%;
        max-width: 100%;
    }
}

#sandbox {
    @media screen and (max-width: $mobile-breakpoint) {
        max-width: 100%;
    }
}

.task {
    display: block;
    margin: auto;
    width: 90%;

    @media screen and (max-width: $mobile-breakpoint) {
        width: 100%;
        height: calc(100vh - 115px);
        margin-top: 2rem;
    }

    .choices {
        display: flex;
        flex-wrap: wrap;
        flex-direction: row;
        justify-content: space-around;
    }
}

td,
th {
    padding: 8px;
}

.taskChoices {
    $standard-image-size: 300px;
    $mobile-image-size: calc(100vw / 2);

    width: $standard-image-size;
    height: $standard-image-size;
    margin: 25px;
    &:hover {
        cursor: pointer;
    }
    @media screen and (max-width: $mobile-breakpoint) {
        width: $mobile-image-size;
        height: $mobile-image-size;
        margin: 0 auto;
    }

    img {
        width: $standard-image-size !important;
        height: $standard-image-size !important;
        border: rgba(255, 255, 255, 0) solid 5px;
        border-radius: 5px !important;
        &:hover {
            border: #afdeee 5px solid;
        }

        @media screen and (max-width: $mobile-breakpoint) {
            width: $mobile-image-size !important;
            height: $mobile-image-size !important;
            margin: 0 auto;
        }
    }
}

img.iqt-mat-choice-image {
    /* box-shadow: 0 0 3px 2px #00e62e; */
    box-shadow: none !important;
    border-radius: 5px;
    width: 125px;
    height: 90px;
    &.active {
        outline: 3px solid rgb(60, 239, 19);
        outline-offset: -3px;
    }
    &.disabled {
        outline: 3px solid rgb(159, 159, 159);
        outline-offset: -3px;
        &:hover {
            cursor: not-allowed;
        }
    }
}

.choices-container {
    display: grid;
    margin-top: 15px;
    grid-row-gap: 15px;
    &.with-three-columns {
        grid-template-columns: repeat(3, 1fr);
        .choices {
            display: flex;
            justify-content: center;
            img {
                &:hover {
                    cursor: pointer;
                }
            }
        }
        @media screen and (max-width: $mobile-breakpoint) {
            grid-row-gap: 5px !important;
            max-width: 100% !important;
            overflow: hidden;
            img {
                $mobile-image-width: calc(100vw / 3);
                width: $mobile-image-width !important;
                height: calc($mobile-image-width * 0.72) !important;
            }
        }
    }
    &.with-four-columns {
        grid-template-columns: repeat(4, 1fr);
        .choices {
            display: flex;
            justify-content: center;
            img {
                &:hover {
                    cursor: pointer;
                }
            }
        }
        @media screen and (max-width: $mobile-breakpoint) {
            grid-row-gap: 0px !important;
            max-width: 100% !important;
            overflow: hidden;
            img {
                $mobile-image-width: calc(100vw / 4);
                width: $mobile-image-width !important;
                height: calc($mobile-image-width * 0.72) !important;
            }
        }
    }
}

div.play-audio-on-demand {
    text-align: center;
    max-height: 28px;
    svg.fa-icon {
        color: rgb(51, 122, 183) !important;
        -webkit-filter: drop-shadow(3px 3px 2px rgba(0, 0, 0, 0.25));
        filter: drop-shadow(3px 3px 2px rgba(0, 0, 0, 0.25));
        &:focus,
        &:active {
            color: rgb(112, 173, 227) !important;
        }
    }
}

.noUi-tooltip {
    display: none !important;
}

// .sv_main {
//   min-height: 100%;
// }

// .sv_qstn {
//   width: auto;
//   margin: 2em;
//   padding-right: 0;
//   overflow: visible !important;
// }

// .sv_qstn td {
//     width: auto;
// }

// .sv_qstn fieldset {
//   display: flex;
//   flex-direction: column;
//   justify-content: space-between;
// }

// .sv_item {
//   font-size: 1em;
//   font-weight: normal;
//   margin-bottom: 5px;
// }

// .sv_label {
//   width: auto;
//   font-weight: 300;
// }

// .sv_item>.sv_label>input[type=radio] {
//   display: none;
// }

// .sv_label>span {
//   display: none;
// }

// .sv_label>span[title] {
//   display: block;
//   width: 100%;
//   border: 3px solid #ccc;
//   border-radius: .5em;
//   padding-left: 0.25em;
// }

// .sv_label{
//   &>*{pointer-events:none;}
// }

// .sv_label>input[type=radio]:checked~span[title] {
//   border: 3px solid #0075ff;
// }

// .sv_title {
//   font-size: 1em;
//   font-weight: 600;
// }

// .sv_qstn_error_top {
//   color: rgb(255, 62, 62);
// }

// .sv_completed_page {
//   text-align: center;
//   padding-top: 8em;
// }

// .sv_page_title {
//   text-align: center;
//   font-weight: 600;
//   font-size: 1.2em;
// }

// .sv_nav {
//     display: flex;
//     flex-direction: row;
//     justify-content: center;
//     padding: 2em;
//     gap: 1em;
// }

// .sv_q_matrix {
//     table-layout: fixed;
//     width: 100%;
//     border-collapse: collapse;
// }

// .sv_q_matrix thead tr th {
//     text-align: center;
// }

// .sv_q_matrix tbody tr td:first-child {
//     width: 40%;
// }

// .sv_q_matrix tbody tr td:not(:first-child) {
//     text-align: center;
// }

// .sv_header > .sv_header__text {
//     display: none !important;
// }
</style>



// WEBPACK FOOTER //
// App.vue?7e206e6f